import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';
import { goToUrl } from '../Table/tableActions';

export const PAYOUT_RECIPIENTS_LOAD = 'PAYOUT_RECIPIENTS/PAYOUT_RECIPIENTS_LOAD';
export const PAYOUT_RECIPIENTS_SUCCESS = 'PAYOUT_RECIPIENTS/PAYOUT_RECIPIENTS_SUCCESS';
export const PAYOUT_RECIPIENTS_FAILURE = 'PAYOUT_RECIPIENTS/PAYOUT_RECIPIENTS_FAILURE';

export const fetchUrl = `${config.payoutApiUrl}/recipient`;

export function getPayoutRecipients(filters, page, pageSize, sorters, payoutAccountIds, columns) {
    const queryParamsString = createQueryParams({
        dateKey: 'updatedAt',
        filters,
        payoutAccountIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getPayoutRecipientsFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: PAYOUT_RECIPIENTS_LOAD,
        successActionTypeOrCreator: getPayoutRecipientsSuccessActionCreator
    };
}

export function getPayoutRecipientsSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, PAYOUT_RECIPIENTS_SUCCESS, 'payoutRecipients');
}

export function getPayoutRecipientsFailureActionCreator(error) {
    return {
        error,
        type: PAYOUT_RECIPIENTS_FAILURE
    };
}

export function selectRecipient(history, recipient, newTab) {
    goToUrl(history, `/payout-recipient/${recipient.recipientId}`, newTab);
}
